/* eslint-disable class-methods-use-this */
import { Requests } from '@nx-smartmonkey/shared/helpers';
import { BillingPeriod } from '../../domain/subscription/Subscription';
import { SubscriptionInvoice } from '../../domain/subscription/SubscriptionInvoice';
import { SubscriptionInvoiceDTO } from '../../domain/subscription/SubscriptionInvoiceDTO';
import { SessionRepository } from '../session/SessionRepository';
import { Pricing, SubscriptionRepository } from './SubscriptionRepository';

export class SubscriptionRepositoryApi implements SubscriptionRepository {
  constructor(private requests: Requests, private sessionRepository: SessionRepository) {}

  async fetchInvoices(): Promise<SubscriptionInvoice[]> {
    const response = await this.requests.get({
      uri: `/organization/subscription/invoices`,
      params: {},
      headers: this.sessionRepository.getAuthenticationHeader(),
    });

    const invoices = response.data as SubscriptionInvoiceDTO[];

    return invoices.map((invoice) =>
      SubscriptionInvoice.create({
        id: invoice.id,
        bill_number: invoice.bill_number,
        date: invoice.date,
        invoice_pdf: invoice.invoice_pdf,
        amount: invoice.amount,
        status: invoice.status,
      })
    );
  }
  async createPortalSession(returnUrl: string): Promise<string> {
    const response = await this.requests.get({
      uri: `/organization/subscription/portal?return_url=${returnUrl}`,
      headers: this.sessionRepository.getAuthenticationHeader(),
    });
    return response.data.url;
  }

  async getPricing({ billingPeriod }: { billingPeriod?: BillingPeriod }): Promise<Pricing> {
    const urlParams = new URLSearchParams();
    if (billingPeriod) urlParams.append(`billing_period`, `${billingPeriod}`);

    const response = await this.requests.get({
      uri: `/organization/subscription/pricing?${urlParams.toString()}`,
      headers: this.sessionRepository.getAuthenticationHeader(),
    });

    return response.data as Pricing;
  }
}
